<template>
  <el-dialog
    :title="title"
    :visible.sync="value"
    width="80%"
    :before-close="handleCloseDailog"
    @open="handleOpenDailog"
  >
    <el-form
      ref="entityData"
      :model="entityData"
      :rules="rules"
      label-width="100px"
      class="demo-ruleForm"
      label-position="right"
    >
      <el-row :gutter="20">
        <!-- 日期 -->
        <el-col :span="12">
          <el-form-item prop="noteDay" label="日期" placeholder="选择日期">
            <el-date-picker
              v-model="entityData.noteDay"
              type="date"
              clearable
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
        </el-col>

        <!-- 分类Key -->
        <el-col :span="12">
          <el-form-item prop="fenLeiDictKey" label="分类">
            <Combox
              v-model="entityData.fenLeiDictKey"
              type-id="D85"
              :option-data="getComboxData('D85')"
              :add-client="false"
            />
          </el-form-item>
        </el-col>

        <!-- 标签 -->
        <el-col :span="24">
          <el-form-item prop="tagList" label="标签">
            <el-select
              v-model="entityData.tagList"
              multiple
              filterable
              allow-create
              default-first-option
              size="small"
            >
              <el-option
                v-for="item in allTags"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </el-form-item>
        </el-col>

        <!-- 标题 -->
        <el-col :span="24">
          <el-form-item prop="title" label="标题">
            <el-input v-model="entityData.title" clearable />
          </el-form-item>
        </el-col>

        <!-- 内容 -->

        <el-col :span="24">
          <el-form-item prop="content" label="内容">
            <el-input
              v-model="entityData.content"
              clearable
              type="textarea"
              :rows="5"
            />
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="关联">
            <el-select />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="dialog-footer">
      <el-button
        v-if="entityId"
        type="danger"
        style="float:left"
        @click="handleDel"
      >
        删 除
      </el-button>
      <el-button @click="handleCloseDailog">取 消</el-button>
      <el-button type="primary" @click="handleSave()">
        保 存
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
import pathReq from '@/api/pathlist'
import Combox from '@/views/managesystem/gz/com/Combox'
import KxjCom from '@/utils/kxjcom'
export default {
  components: {
    Combox
  },
  props: {
    value: { type: Boolean, default: false },
    entityId: { type: Number, default: null },
    defaultDay: { type: String, default: null }
  },
  data() {
    return {
      entityData: {},
      allComboxData: [],
      title: '',
      rules: {
        noteDay: [
          { required: true, message: '请选择日期', trigger: 'change,blur' }
        ],
        title: [
          { required: true, message: '请输入标题', trigger: 'change,blur' }
        ],
        content: [
          { required: true, message: '请输入内容', trigger: 'change,blur' }
        ]
      },
      selectedValue: [],
      allTags: []
    }
  },
  computed: {},
  created() {
    /** 下拉框数据 */
    pathReq.getComboxDatasByIdArray('D85').then(res => {
      this.allComboxData = res.data.result
    })
  },
  activated() {
    this.init()
  },
  methods: {
    init() {},
    handleCloseDailog() {
      this.$emit('input', false)
    },
    handleOpenDailog() {
      this.title = this.entityId ? '修改/删除日记' : '新增日记'
      this.handleSearch()
    },
    // combox筛选值
    getComboxData(typeId) {
      return this.allComboxData.filter(function(item) {
        return item.typeId === typeId
      })
    },
    /**
     * 初始化数据
     */
    handleSearch() {
      let path = '/api/services/app/note/GetEditnote'
      if (this.entityId) {
        path += '?Id=' + this.entityId
      }
      pathReq.getNoParams(path).then(res => {
        this.entityData = res.data.result.entityData
        this.allTags = res.data.result.allTags
        if (!this.entityId) {
          this.entityData.noteDay = this.defaultDay
        }
      })
    },
    /**
     * 打开数据字典弹出框
     */
    handleAddComboxData(dictTypeId, dictTypeName) {
      this.$bus.emit('comboxData', dictTypeId, dictTypeName)
    },
    /**
     * 新增或者修改身份信息数据
     */
    handleSave() {
      this.$refs['entityData'].validate(valid => {
        if (valid) {
          const that = this
          const path = '/api/services/app/note/CreateOrUpdatenote'

          pathReq.postForm(path, { entityData: that.entityData }).then(res => {
            that.$message.success('保存成功')
            this.$emit('save-success')
            this.$emit('input', false)
          })
        }
      })
    },
    /** 删除 */
    handleDel() {
      if (!this.entityId) {
        return
      }
      const loading = this.$loading(KxjCom.loadOptions)
      this.$confirm('确定要删除该数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$loading(KxjCom.loadOptions)
        const path = '/api/services/app/note/Deletenote'
        pathReq.dataDelete(path, this.entityId).then(res => {
          this.$emit('save-success')
          this.$emit('input', false)
          this.$message.success('删除成功!')
          loading.close()
        })
      }).catch(() => {
        loading.close()
      })
    }
  }
}
</script>
<style scoped>
.el-dialog__body {
  padding-top: 10px !important;
}

.dialog-footer {
  text-align: right;
}

.el-select {
  margin-right: 8px;
  width: 84% !important;
}
</style>
